import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import {ServerGroupGetSchema} from '../../../../api/DBSchema/Server';
import Sepperator from '../../../../components/Simple/Sepperator';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import Indentation from '../../../../components/Simple/Indentation';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';

const pageSchema = ServerGroupGetSchema.pages.general;
const pageId = pageSchema.pageId;

function ServerGroupGeneral({
    serverGroupObject,
    setServerGroupData
}) {
    const { t } = useTranslation();

    const pageData = serverGroupObject[pageId];
    const setPageValue = useCallback((paramName, value) => {
        setServerGroupData([pageId, paramName], value);
    }, [setServerGroupData]);
    
    const description             = pageData[pageSchema.description];
    const smartlogServerAddress   = pageData[pageSchema.smartLogServerAddress];
    const smartEventServerAddress = pageData[pageSchema.smartEventServerAddress];
    const isDRMEnabled            = pageData[pageSchema.isDRMEnabled];

    return (
        <EditorLayout>
            <SMCTextInput
                value={description}
                onChange={e => setPageValue(pageSchema.description, e.target.value)}
                label={t('SMP.DESCRIPTION')}
            />
            <SMCTextInput
                value={smartlogServerAddress}
                onChange={e => setPageValue(pageSchema.smartLogServerAddress, e.target.value)}
                label={t('SMP.SYSTEM.SMP_SERVERS.SERVER_GROUP_SETTINGS.SMART_LOG_ADDRESS')}
                />
            <SMCTextInput
                value={smartEventServerAddress}
                onChange={e => setPageValue(pageSchema.smartEventServerAddress, e.target.value)}
                label={t('SMP.SYSTEM.SMP_SERVERS.SERVER_GROUP_SETTINGS.SMART_EVENT_SERVER_ADDRESS')}
            />
            <Sepperator />
            <SMCLabel bold>{t('SMP.SYSTEM.SMP_SERVERS.SERVER_GROUP_SETTINGS.MODULES')}</SMCLabel>
            <Indentation>
                <SMCCheckbox
                    checked={isDRMEnabled}
                    onChange={e => setPageValue(pageSchema.isDRMEnabled, e.target.checked)}
                    label={t('SMP.SYSTEM.SMP_SERVERS.SERVER_GROUP_SETTINGS.DRM')}
                />
            </Indentation>
        </EditorLayout>
    )
}

export default ServerGroupGeneral;